<!-- 表1填写 -->

<template>
  <div class="tabCage ssTab3">
    <div class="tabTtl">
      <span>经营情况信息</span>
      <div class="tabBtns" style="float: right;">
        <el-button type="primary" size="small" class="importBtn" @click="getCode403HistoryData">导入历史数据</el-button>
      </div>
    </div>

    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="headBar">
        <span>{{ yearSet.year1 }}年</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">出版单位年销售收入（万元）：</td>
            <td class="edInp">
              <el-form-item prop="firstTotalSales" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.firstTotalSales"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版单位年利润总额（万元）：</td>
            <td class="edInp">
              <el-form-item prop="firstTotalProfit" :inline-message="true">
                <el-input-number controls-position="right" :precision="2" v-model="params.firstTotalProfit"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物年销售收入（万元）：</td>
            <td class="edInp">
              <el-form-item prop="firstSales" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.firstSales"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物年利润总额（万元）：</td>
            <td class="edInp">
              <el-form-item prop="firstProfit" :inline-message="true">
                <el-input-number controls-position="right" :precision="2" v-model="params.firstProfit"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
        </table>

      </div>
      <div class="headBar">
        <span>{{ yearSet.year2 }}年</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">出版单位年销售收入（万元）：</td>
            <td class="edInp">
              <el-form-item prop="secondTotalSales" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.secondTotalSales"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版单位年利润总额（万元）：</td>
            <td class="edInp">
              <el-form-item prop="secondTotalProfit" :inline-message="true">
                <el-input-number controls-position="right" :precision="2" v-model="params.secondTotalProfit"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物年销售收入（万元）：</td>
            <td class="edInp">
              <el-form-item prop="secondSales" :inline-message="true">
                <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.secondSales"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">连续型电子出版物年利润总额（万元）：</td>
            <td class="edInp">
              <el-form-item prop="secondProfit" :inline-message="true">
                <el-input-number controls-position="right" :precision="2" v-model="params.secondProfit"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
        </table>
        <div class="headBar">
          <span>申报人信息</span>
        </div>
        <div class="editArea">
          <table>
            <tr>
              <td class="edName">申报人：</td>
              <td class="edInp">
                <el-input v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">联系方式：</td>
              <td class="edInp">
                <el-input v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
              </td>
            </tr>
            <tr>
              <td class="edName">申报时间：</td>
              <td class="edInp">
                <el-input v-model="params.updatedAt" size="small" :disabled="true""></el-input>
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </el-form>

                          <div class=" subArea">
                  <el-button @click="goBack" size="small">返回</el-button>
                  <el-button v-if="modifyFlag" type="primary" @click="editSave('paramCk')" size="small"
                    :disabled="submiting">
                    <span v-if="submiting">提交中</span>
                    <span v-else>保存</span>
                    <i v-if="submiting" class="el-icon-loading"></i>
                  </el-button>
        </div>

      </div>
</template>

<script>
import {
  bsParams,
  paramsRule
} from '@/components/LongParams/paramsSEt3';
import {
  ssSave3,
  ssRead3,
  code403HistoryData,
  getLxdzModifyFlagByPublication,// zym.判断数据是否可以修改
} from '@/api/pressRole/pressSuccessive';
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,

      yearSet: {
        year1: '',
        year2: ''
      },
      declare: {
        personnel: "",
        contact: ""
      }
    }
  },
  watch: {
    'params.areaDate': function (dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    editSave: function (name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;

          this.params.firstYear = this.yearSet.year1;
          this.params.secondYear = this.yearSet.year2;
          if (!this.declare.personnel) {
            this.$message.error('申报人姓名必填');
            return
          };
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!this.declare.contact) {
            this.$message.error('申报人联系方式必填');
            return
          };
          ssSave3({
            data: this.params,
            // plxdzfinance: this.params,
            organizationPersonnel: this.declare
          }).then(response => {
            console.log('response=', JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.tipMessage;
            if (tipCode == 'fail') {
              this.$message({
                message: tipMessage,
                type: 'error'
              })
            }
            else {
              this.submiting = false;
              this.$message({
                message: '保存成功！',
                type: 'success'
              });

              this.goBack();
            }
          }).catch(error => {
            this.submiting = false;
          })
        } else {
          return false;
        }
      })
    },
    //获取历史导入数据
    getCode403HistoryData: function () {
      let that = this;
      this.imgId = '';
      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      code403HistoryData({
        publishMaterialId: this.$route.query.mtId,
      }).then(response => {
        loading.close();
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = { ...that.params, ...response.plxdzfinance, publishMaterialId: that.$route.query.mtId, };
        // that.imgId = response.plxdzPublication.yyzzId;
        if (response.pOrganizationPersonnel !== null) {
          that.declare.contact = response.pOrganizationPersonnel.contact;
          that.declare.personnel = response.pOrganizationPersonnel.personnel;
          that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
        that.layChange();
      }).catch(error => {
        that.submiting = false;
      })
    },
    tabReEdit: function () {
      ssRead3({
        publishMaterialId: this.$route.query.mtId
      }).then(response => {
        if (response.plxdzFinance) {
          this.params = response.plxdzFinance;
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

          this.modifyFlag = response.modifyFlag;
          console.log('modifyFlag=', this.modifyFlag)
        }
      })
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },

    layChange: function () {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function () {
      this.$router.go(-1);
    }
    // zym.判断是否可以修改
    , getLxdzModifyFlagByPublication: function () {
      console.log('getLxdzModifyFlagByPublication...')
      let vm = this;
      getLxdzModifyFlagByPublication({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(response => {
        vm.modifyFlag = response.payload;
      })
    }
  },
  created: function () {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }

    let newDate = new Date();
    this.yearSet.year1 = newDate.getFullYear() - 2;
    this.yearSet.year2 = newDate.getFullYear() - 1;
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = '';
    }
  }
}
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.ssTab3 {
  margin-top: 0;

  .edInp .el-input-number {
    width: 300px;
  }

  .el-textarea {
    width: 450px;
  }

  .edName {
    width: 300px !important;
  }
}

.el-date-editor {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// ssTab3 copy.vue?710bb928